<template>
  <div class="comment-panel">
    <el-row :gutter="40">
      <el-col :span="8">
        <div class="grid-admire">
          <ig-icon name="dianzan"></ig-icon>
          <span class="count">{{admire}}</span>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-comment">
          <ig-icon name="pinglun"></ig-icon>
          <span class="count">{{comment}}</span>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-share">
          <ig-icon name="fenxiang"></ig-icon>
          <span class="count">{{share}}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  name: 'comment-panel',
  props: {
    admire: {
      type: [Number, String],
      default: 0
    },
    comment: {
      type: [Number, String],
      default: 0
    },
    share: {
      type: [Number, String],
      default: 0
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/client/styles/variables.scss";
.comment-panel {
  width: 100%;
  color: $fontColor;
  i {
    margin-right: 10px;
  }
}
</style>
